<script setup>
/**
 * Aviso permanente de que não se está na própria conta.
 *
 * Mesmo componente e mesmo motivo do accounts (ver o arquivo irmão em
 * apps/accounts/resources/components/common/FaixaPersonificacao.vue): quem
 * personifica esquece, e o custo de uma faixa fixa é menor do que o de
 * alguém operar em nome de outra pessoa sem perceber.
 */
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import messageService from '@/services/messages.js';
import { handleError } from '@/utils/errors.js';
import { atorAtual, voltarParaMim } from '@/services/personificacao.js';

const { t } = useI18n();

const ator = ref(atorAtual());
const voltando = ref(false);

async function voltar() {
    try {
        voltando.value = true;
        await voltarParaMim();

        // Recarga inteira: identidade nova significa permissao, menu e
        // empresa novos, e o estado montado ficaria com os antigos.
        window.location.href = '/home';
    } catch (error) {
        voltando.value = false;
        messageService.error(await handleError(error.response ?? error, t));
    }
}

defineOptions({ name: 'FaixaPersonificacao' });
</script>

<template>
    <div v-if="ator" class="faixa-personificacao">
        <span>
            {{ t('common.personificacao.faixa', { ator }) }}
        </span>
        <button type="button" :disabled="voltando" @click="voltar">
            {{ voltando ? t('common.personificacao.voltando') : t('common.personificacao.voltar') }}
        </button>
    </div>
</template>

<style scoped>
/*
 * Amarelo de atencao, e nao vermelho: nao e erro, e um estado incomum que
 * precisa ser notado. Texto escuro sobre amarelo mantem o contraste legivel.
 */
.faixa-personificacao {
    position: sticky;
    top: 0;
    z-index: 1100;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
    padding: 8px 16px;
    background: #ffcb05;
    color: #1f2937;
    font-weight: 600;
    font-size: 14px;
}

.faixa-personificacao button {
    background: #1f2937;
    color: #fff;
    border: 0;
    border-radius: 4px;
    padding: 4px 12px;
    font-weight: 600;
    cursor: pointer;
}

.faixa-personificacao button:disabled {
    opacity: 0.6;
    cursor: default;
}
</style>
